import {Injectable} from "@angular/core";
import {AbstractSqliteDatabase} from "./abstract-sqlite.database";

@Injectable({ providedIn: 'root' })
export class CmcProductManagerDatabase extends AbstractSqliteDatabase {

    constructor() {
        super("cmc_product_manager_store", "cmc_products");
    }

}